import React from 'react';
import OwlCarousel from "react-owl-carousel";
import  {useClientdata} from "../FetchAPI";


export default function DataContent() {
      const [clientdata] = useClientdata();

        const clientOwl = {
          loop: true,
          margin: 30,
          responsiveClass: true,
          nav: false,
          dots: false,
          autoplay: true,
          navText: ["&lt;", ">"],
          smartSpeed: 1000,
          center: true,
          responsive: {
            0: {
              items: 1,
            },
            400: {
              items: 1,
            },
            600: {
              items: 1,
            },
            700: {
              items: 2,
            },
            1000: {
              items: 3,
            },
          },
        };
      

  return (
    <>

      {/* Client Section Start */}
      <section id="client_section" className="client_section_new">
        <div className="container">
          <div className="client_heading_area">
            <span className="client_subtitle">
              TESTIMONIALS
            </span>
            <h2 className="client_main_title">
              Clients Had To Say
            </h2>
            <p className="client_heading_text">
              Trusted by thousands of satisfied customers across India.
            </p>
          </div>

          <div className="slider">
            <OwlCarousel className="owl-theme" {...clientOwl}>
              {clientdata?.map((value, index) => (
                <div key={index} className="testimonial_card item">
                  <div className="testimonial_avatar_wrap">
                    <img src={value.image} className="testimonial_avatar" alt={value.name} />
                  </div>
                  <div className="testimonial_content">
                    <h3 className="testimonial_name">{value.name}</h3>
                    <p className="testimonial_designation"><b>{value.designation}</b></p>
                    <p className="testimonial_text">{value.description}</p>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </section>
      {/* Client Section End */}



    </>
  );
}
